/**
 * The Settings "Keybinds" reference, DERIVED from the panel registry (`panels/index.tsx`)
 * instead of a hand-kept copy (q-debug-panel-shipped-to-players, AD-820). The old copy advertised
 * the developer panel's backtick key to every player, including guests; a derived list cannot
 * list a key for a panel this build did not register, or one a guest cannot open.
 *
 * Pure (no React, no DOM) so it runs under `node --test`.
 */

import { guestPanelAllowed } from '../../guest/guestWalls.js';

/** The slice of a registry `PanelDef` the reference needs. */
export interface PanelKeyDef {
  readonly id: string;
  readonly title: string;
  readonly hotkey: string;
}

/** Keys that are not panels (capture + window controls). Panel rows come from the registry. */
export const NON_PANEL_KEYBINDS: readonly (readonly [string, string])[] = [
  ['F3', 'Hide HUD (capture)'],
  ['F4', 'Capture mode'],
  ['[ ]', 'Cycle camera preset'],
  ['Esc', 'Close topmost window'],
];

/** Panel rows (registry order, a guest sees only the panels it can open) then the fixed rows. */
export function keybindRows(panels: readonly PanelKeyDef[], guest: boolean): [string, string][] {
  const rows: [string, string][] = panels
    .filter((p) => !guest || guestPanelAllowed(p.id))
    .map((p) => [p.hotkey, p.title]);
  for (const [k, v] of NON_PANEL_KEYBINDS) rows.push([k, v]);
  return rows;
}
